<template>
  <div class="search">
    <!-- left-arrow -->
    <!-- @click-left="onClickLeft" -->
    <van-nav-bar

      >
      <template #title>
        <div class="search-cont">
          <form action="/">
            <van-search
              show-action
              placeholder="搜索职位"
              v-model="jobs.query.jobName"
              @search="onSearch"
              @cancel="onCancel">
              <template #action>
                <div @click="onSearch">搜索</div>
              </template>
            </van-search>
          </form>
        </div>
      </template>
    </van-nav-bar>
    <div class="search-condition">
      <ul class="condition">
        <li class="select">搜职位</li>
        <li @click="company">搜公司</li>
      </ul>
      <ul class="pop-select">
        <li @click="showPickerPlace">{{place}}</li>
        <li @click="filterPop = true">筛选</li>
      </ul>
    </div>

    <!--empty-->
    <van-empty
      v-if="jobs.dataList.length==0 && isShow"
      class="custom-image"
      :image="require('@/assets/img/empty.png')"
      description="暂未搜索到相关的职位"
    >
      <p>换个关键词试一试吧～</p>
    </van-empty>

    <van-list
      v-model="jobs.status.loading"
      :finished="jobs.status.finished"
      finished-text="没有更多了"
      @load="jobOnLoad(jobs)"
    >
      <ul class="job-list">
        <li
          v-for="item in jobs.dataList"
          :key="item.index"
          @click="jobDetail(item.id)"
        >
          <div class="detail-info">
            <div class="info-header">
              <h3>{{ item.jobName }} <small v-if="item.urgent">急</small></h3>
              <span>{{ item.salary }}</span>
            </div>
            <ul class="conditionList">
              <li v-text="item.expLevel"></li>
              <li v-text="item.eduLevel"></li>
            </ul>
            <ul class="feature">
              <li v-text="item.enterpriseName"></li>
              <li v-text="item.personnelSize"></li>
            </ul>
            <div class="contact">
              <div class="person">
                <img
                  v-if="item.recruitersAvatar"
                  :src="item.recruitersAvatar"
                />
                <img v-else :src="require('@/assets/img/avatar.png')" />
                <span
                  >{{ item.recruitersName }} ·
                  {{ item.recruitersJobTitle }}</span
                >
              </div>
              <div class="place">
                {{ item.jobArea }}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </van-list>

    <!-- 弹框 -->
    <!--智能筛选-->
    <transition name="fade">
      <div class="filter-cont" v-show="filterPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenPop"></van-icon>
          <h2>智能筛选</h2>
        </div>
        <h3>期望月薪 <small>（单选/元）</small></h3>
        <ul class="filter-list">
          <li
            v-for="(item, index) in salaryList"
            :key="item.index"
            :class="{ checked: index == salaryActive }"
            @click="selectSalary(index)"
          >
            <span>{{ item.title }}</span>
          </li>
        </ul>
        <h3>工作年限 <small>（单选）</small></h3>
        <ul class="filter-list">
          <li
            v-for="(item, index) in seniorityList"
            :key="item.index"
            :class="{ checked: index == seniorityActive }"
            @click="selectSeniority(index)"
          >
            <span>{{ item.title }}</span>
          </li>
        </ul>
        <h3>学历要求 <small>（多选）</small></h3>
        <ul class="filter-list">
          <li
            v-for="(item, index) in educationList"
            :data-index="index"
            :key="item.index"
            @click="selectEducation(index)"
            :class="{ checked: item.check }"
          >
            <span>{{ item.title }}</span>
          </li>
        </ul>
        <h3>福利筛选 <small>（多选）</small></h3>
        <ul class="filter-list">
          <li
            v-for="(item, index) in welfareList"
            :data-index="index"
            :key="item.index"
            @click="selectWelfare(index)"
            :class="{ checked: item.check }"
          >
            <span>{{ item.welfare }}</span>
          </li>
        </ul>
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-gray" color="#EEEFF1" round @click="clearMoreSelect"

            >清 除</van-button
          >
          <van-button
            type="primary"
            class="btn-blue"
            color="linear-gradient(to right top, #2F72F6,#1C54CF)"
            round
            @click="screenMoreClick"
            >确 定</van-button
          >
        </div>
      </div>
    </transition>

    <van-popup v-model="showPlace" round position="bottom">
      <van-picker
        show-toolbar
        value-key="title"
        :columns="areaLabelList"
        @cancel="closePlace"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'searchJob',
  data() {
    return {
      isShow:false,
      filterPop: false,
      showPlace: false,
      place: '区域',
      areaLabelList: [],
      jobs: {
        dataList: [],
        query: {
          current: 0,
          size: 10,
          urgent:'',
          jobArea:'',
        },
        status: {
          loading: false,
          finished: false
        }
      },
      // 期望月薪(单选) List
      salaryList: [],
      salaryActive: -1,
      // 工作年限(单选) List
      seniorityList: [],
      seniorityActive: -1,
      // 学历要求(多选) List
      educationList: [],
      // 获取标签(多选) List
      welfareList: []
    }
  },
  methods: {
    onload() {
      // 期望月薪
      this.httpDictBiz("salary_level", this.salaryList);
      // 工作年限
      this.httpDictBiz("work_exp_level", this.seniorityList);
      // 学历要求
      this.httpDictBiz("edu_type", this.educationList);
      // 获取标签
      this.httpLabel();
    },
    httpDictBiz(code, dataList) {
      this.module.api.bizDict({
        params: { code },
        success: records => {
          const resultList = records;
          for (let i = 0; i < resultList.length; i++) {
            dataList.push({
              ...resultList[i],
              title: resultList[i].dictValue,
              check: false
            });
          }
        }
      });
    },
    httpLabel() {
      this.module.api.labelAll({
        params: { type: 0 },
        success: data => {
          this.welfareList.length = 0;
          const resultList = data;
          for (let i = 0; i < resultList.length; i++) {
            this.welfareList.push({
              ...resultList[i],
              welfare: resultList[i].name,
              check: false
            });
          }
        }
      });
    },
    jobOnLoad(listParams) {
      listParams.query.current++;
      this.httpDate(listParams);
    },
    httpDate({ query, dataList, status }) {
      this.module.api.posList({
        data: query,
        method: "post",
        success: (data) => {
          if (query.current === 1) {
            dataList.length = 0;
          }
          const resultList = data.records;
          for (let i = 0; i < resultList.length; i++) {
            dataList.push(resultList[i]);
          }
          if(resultList.length == 0){
            dataList.splice(0,dataList.length)
            dataList = []
          }
          // 改变list状态
          if (status) {
            status.finished = !(query.current < data.pages);
            status.loading = false;
          }
          this.isShow = true
        }
      });
    },
    jobDetail(id) {
      this.$router.push({ path: "jobDetail", query: { id } });
    },
    /**
     * 获取区域列表
     */
    loadArea(pid,grade) {
      this.module.api.area({
        params: {parentId: pid,grade},
        success: (records) => {
          let labelList = [];
          for (let i = 0; i < records.length; i++) {
            labelList.push({
              ...records[i],
              text:records[i].title
            });
          }
          this.areaLabelList = labelList;
        }
      })
    },
    hiddenPop() {
      this.filterPop = false;
    },
    showFilterPop() {
      this.filterPop = true;
    },
    /**
     * 清除更多选择
     */
    clearMoreSelect(){
      // console.log("6655")
      this.salaryActive = -1
      this.seniorityActive = -1
      // 清除学历要求
      for(let i of this.educationList){
        i.check = false
      }
      // 清除福利筛选
      for(let i of this.welfareList){
        i.check = false
      }

    },
    /**
     * 筛选更多确定
     */
    screenMoreClick(){
      let salary = ''
      let expLevel = ''
      let eduLevels = []
      let positionLabels = []

      if(this.salaryActive && this.salaryActive != -1 && this.salaryActive < this.salaryList.length){
        salary = this.salaryList[this.salaryActive].dictKey
      }
      if(this.seniorityActive && this.seniorityActive != -1 && this.seniorityActive < this.seniorityList.length){
        expLevel = this.seniorityList[this.seniorityActive].dictKey
      }

      // 学历要求
      for(let i of this.educationList){
        if(i.check){
          eduLevels.push(i.dictKey)
        }
      }
      // 福利筛选
      for(let i of this.welfareList){
        if(i.check){
          positionLabels.push(i.id)
        }
      }
      // console.log('salary',salary)
      // console.log('expLevel',expLevel)
      // console.log('eduLevels',eduLevels)
      // console.log('positionLabels',positionLabels)

      this.jobs.query.current = 0
      this.jobs.query.salary = salary
      this.jobs.query.expLevel = expLevel
      this.jobs.query.eduLevels = eduLevels
      this.jobs.query.positionLabels = positionLabels

      this.jobOnLoad(this.jobs)
      this.filterPop = false


    },
    onClickLeft() {
      this.$router.go(-1)
    },
    onSearch() {
      this.jobs.query.current = 0
      // this.jobs.query.jobName = ""
      this.jobOnLoad(this.jobs)

      // this.$router.push({ name: 'result' })
    },
    closePlace() {
        this.showPlace = false
    },
    selectSalary(index) {
      if(index === this.salaryActive){
        this.salaryActive = -1
      }else{
        this.salaryActive = index;
      }

    },
    selectSeniority(index) {
      if(index === this.seniorityActive){
        this.seniorityActive = -1
      }else{
        this.seniorityActive = index;
      }
    },
    selectEducation(idx) {
      var check = this.educationList[idx].check;
      this.educationList[idx].check = !check;
    },
    selectWelfare: function(idx) {
      var check = this.welfareList[idx].check;
      this.welfareList[idx].check = !check;
    },
    onCancel() {

    },
    onConfirm(value) {
      this.place = value.text
      this.showPlace = false
      console.log(value)
      this.jobs.query.current = 0
      this.jobs.query.jobArea = value.id
      console.log(this.jobs)
      this.jobOnLoad(this.jobs)
    },
    company() {
      this.$router.push({ name: 'searchCompany' })
    },
    showPickerPlace() {
      this.showPlace = true
    }
  },
  mounted(){
    this.onload()
    //嘉定区 id
    this.loadArea(0,2);
  }
}
</script>

<style lang="less" scoped>
  .job-list > li .detail-info .contact .person img{
    width: 22px;
    height: 22px;
    margin-right: 6px;
  }
  .search-condition{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin:10px 16px 20px;
    ul{
      display: flex;
      align-items: center;
      li{
        color:#B7BABF;
        font-size: 12px;
        padding:6px 12px;
      }
      &.condition{
        .select{
          background: #F5F2EF;
          color:#2E3133;
          border-radius: 50px;
        }
      }
      &.pop-select{
        li{
          position: relative;
          &:after{
            content: '\e629';
            position: absolute;
            right:-6px;
            top:10px;
            font-family: van-icon;
          }
        }
      }
    }
  }
  .job-list{
    margin-left: 0;
    margin-right: 0;
    &>li{
      padding:6px 16px;
      border-bottom: 8px solid #F7F7F7;
      &:last-child{
        border-bottom: 0;
      }
    }
  }
</style>
